import { InjectionToken } from '@angular/core';

/**
 * Injection token for the public API base URL.
 * Used by public-facing components that don't require authentication.
 */
export const PUBLIC_API_BASE_URL = new InjectionToken<string>('PUBLIC_API_BASE_URL');
